/* eslint-disable max-classes-per-file */
import * as React from 'react';
import { AppTextLabel } from '@@services/i18nservice';
import type { IAppShellHeaderPartProps } from './appshellheader';
import { actions as i18nActions } from '@@services/i18nservice';
import { AppShellHeaderActionButton } from './appshellheaderactionbutton';
import { bindActionCreators } from 'redux';
import { connectwith } from '@inwink/react-utils/decorators/connectwith';
import { setMappings } from '@@modules/admin/api/bohelp';

export interface IAppShellHelpProps extends IAppShellHeaderPartProps {
    i18nActions?: typeof i18nActions;
    afterClick: () => void;
    parent: any;
    display: "simple" | "advanced";
}

export const helpBaseUrl = "https://help.inwink.com/";

@connectwith(null, (dispatch) => ({ i18nActions: bindActionCreators(i18nActions, dispatch) }))
export class AppShellHelp extends React.Component<IAppShellHelpProps, any> {
    
    
    openTools = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();

        import("@@components/aiassistantagent/index").then((mod) => {
            let rooturl = helpBaseUrl;
            const lang = this.props.i18n.currentLanguageCode;
        
            if (lang === "fr") {
                rooturl = `${rooturl}${lang}`;
            }
        
            const targetPage = this.props.i18n.helpmappings && this.props.featurecode
                && this.props.i18n.helpmappings[this.props.featurecode];
            this.props.popovermgr.sidemodalPortal(mod.AiAssistantAgent, {
                ...this.props,
                helpPage: targetPage || rooturl
            }, "aiassistant-agent-sidemodal");
        });

        this.props.afterClick();
    };

    openHelp = (url: string) => {
        const rooturl = url;

        const targetPage = this.props.i18n.helpmappings && this.props.featurecode
            && this.props.i18n.helpmappings[this.props.featurecode];
        if (targetPage) {
            window.open(targetPage, "_blank");
        } else {
            window.open(rooturl, "_blank");
        }

        this.props.afterClick();
    };

    render() {
        const onClick = (arg) => this.openTools(arg);
        
        if (this.props.display === 'simple') {
            return <a role="button"
                onClick={onClick}
                target="_blank" rel="noreferrer"
                title={this.props.i18nHelper.translate("appheaderactions.showhelp")}
                className="simple chatbot"
            >
                <i className="inwink-z-chatbot5" />
            </a>;
        }

        
        return <AppShellHeaderActionButton
            icon="inwink-z-chatbot5"
            title="appheaderactions.showhelp"
            className="appshellhelp"
            onClick={onClick}
        />;
    }
}


export interface IAppShellHelpToolsProps extends IAppShellHelpProps {
    onCompleted?: (res?) => void;
}

export class AppShellHelpTools extends React.Component<IAppShellHelpToolsProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            helppage: this.props.i18n.helpmappings && this.props.featurecode
                && this.props.i18n.helpmappings[this.props.featurecode]
        };
    }

    saveHelpPageMapping = () => {
        setMappings(this.props.i18n.currentLanguageCode, this.props.featurecode, this.state.helppage).then(() => {
            return this.props.i18nActions.syncCurrent();
        }).then(() => {
            this.props.onCompleted();
        });
    };

    openHelp = () => {
        // let url = "/docs";
        if (this.state.helppage) {
            // if (this.state.helppage && this.state.helppage[0] === "/") {
            //     url += this.state.helppage;
            // } else { url += "/" + this.state.helppage; }
            window.open(this.state.helppage, "_blank");
        } else {
            window.open(helpBaseUrl, "_blank");
        }
    };

    render() {
        return <div className="bohelp-tools formpage">
            <div>
                <AppTextLabel i18n="bohelp.pageurl" component="label" />
                <input
                    type="text"
                    value={this.state.helppage || ""}
                    onChange={(arg) => this.setState({ helppage: arg.currentTarget.value })}
                />
            </div>
            <div className="actions">
                <button
                    type="button"
                    onClick={this.openHelp}
                ><AppTextLabel i18n="actions.open" /></button>
                <button
                    type="button"
                    onClick={this.saveHelpPageMapping}
                ><AppTextLabel i18n="actions.save" /></button>
            </div>
        </div>;
    }
}
